require("./bootstrap");
import { createApp } from "vue";
import Invoice from "./components/Invoice";
import { plugin, defaultConfig } from "@formkit/vue";
// import '@formkit/themes/genesis'
import store from "./invoice/store";
import "./page-builder/app";
import "./chat/app";
import "./activity-prices/app";
import "./bulk/app";
import "./menu-items/app";
import "./booking-mails/app";
import "./calendar/app";
import "./invoice-builder/app";
import dashboard from "./charts";

const app = createApp({
    components: { Invoice },
});

app.use(
    plugin,
    defaultConfig({
        config: {
            classes: {
                input: 'form-control',
                wrapper: 'form-group',
            },
        },
    })
);
app.use(store);

app.mount("#app");

if (document.querySelector('.dashboard')) {
    dashboard();
}
